module.exports = __webpack_public_path__ + "img/AWS_Logo.fe2efcc1.jpg";